import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/RichText/RichText.js
const RichText = createSectionForm({
  icon: "file-text-line",
  title: "Rich Text",
  fields: [{ name: "content", label: "Content", type: "richtext", height: 260 }],
});

export default RichText;
